import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Magasin — devanture stylisée duotone */
export const StoreIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Auvent menthe */}
      <path
        d="M3 7l1.5-3h15L21 7v1.5a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0V7z"
        fill="var(--equiply-icon-bg)"
      />
      {/* Bâtiment */}
      <path
        d="M4.5 10.5V20h15v-9.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Porte */}
      <path
        d="M10 20v-5.5h4V20"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
    </svg>
  ),
);
StoreIcon.displayName = "StoreIcon";
